import SnackbarComponent from "./snackbar";
import ZoomInOut from "./zoomInOut";
import ConfirmPopup from "./popups/confirmPopup";

export default {
  Snackbar: SnackbarComponent,
  ZoomInOut,
  ConfirmPopup
};
